// Cuál item del menú corresponde a una ruta: gana el MÁS ESPECÍFICO.
//
// `NavLink` sin `end` marca activo por prefijo de segmentos, así que con Query
// Lab viviendo en `/products/query` quedaban encendidos los dos items a la vez,
// Productos y Query Lab. Poner `end` en Productos no alcanza: dejaría de
// encenderse en el detalle (`/products/10012487`), que sí le pertenece.
//
// Devuelve el `to` ganador, o null si ninguno matchea. `/` solo gana exacto:
// es prefijo de todas las rutas.
export function bestMatchingNavPath(
  pathname: string,
  paths: readonly string[],
): string | null {
  let best: string | null = null;
  for (const to of paths) {
    const matches =
      to === '/'
        ? pathname === '/'
        : pathname === to || pathname.startsWith(`${to}/`);
    if (!matches) continue;
    if (best === null || to.length > best.length) best = to;
  }
  return best;
}
